import request from '@/utils/request'

//作業可能日
export function getWorkableDateRequest() {
  return request({
    url: '/api/works/top/partner/task-stats-for-partner',
    method: 'get',
  })
}
// 報告書確認
export function getConfirmReport() {
  return request({
    url: '/api/works/top/partner/report/task-stats-for-partner',
    method: 'get',
  })
}
// 日程調整
export function getScheduleAdj() {
  return request({
    url: '/api/works/top/partner/schedule-tasks-stats-for-partner',
    method: 'get',
  })
}
// 原価見積書等確認
export function getEstimateConfirmation() {
  return request({
    url: '/api/works/top/partner/doc-tasks-stats-for-partner',
    method: 'get',
  })
}

export function workpush(pushId) {
  return request({
    url: `/api/works/top/workpush/${pushId}`,
    method: 'post',
  })
}
export function scStats() {
  return request({
    url: `/api/works/top/partner/sc-stats`,
    method: 'get',
  })
}
export function statistics() {
  return request({
    url: `/api/works/top/statistics`,
    method: 'get',
  })
}
export function monthly(data) {
  return request({
    url: `/api/works/top/statistics/monthly`,
    method: 'post',
    data,
  })
}
export function flashReport() {
  return request({
    url: `/api/works/top/statistics/flashReport`,
    method: 'get',
  })
}
export function officialReport() {
  return request({
    url: `/api/works/top/statistics/officialReport`,
    method: 'get',
  })
}
export function finishFlg() {
  return request({
    url: `/api/works/top/statistics/finishFlg`,
    method: 'get',
  })
}
export function workingPlanAndResults() {
  return request({
    url: `/api/works/top/statistics/workingPlanAndResult`,
    method: 'get',
  })
}
export function resultDateInputStatus() {
  return request({
    url: `/api/works/top/statistics/resultDateInputStatus`,
    method: 'get',
  })
}
